module.exports = __webpack_public_path__ + "img/logo.5ab8f9d7.svg";